export const aboutData = {
  brandIntro: {
    title: "关于银河娱乐",
    subtitle: "行业领先的在线娱乐品牌，致力于为全球玩家提供顶级娱乐体验",
    paragraphs: [
      "银河娱乐官方平台成立于2010年，总部位于亚洲娱乐之都，是一家拥有十多年历史的综合性在线娱乐服务提供商。凭借丰富的行业经验、先进的技术实力和优质的服务理念，银河娱乐已发展成为行业标杆品牌。",
      "我们汇聚了全球顶级游戏开发商的优质资源，平台拥有超过10,000款精品游戏，涵盖电子游艺、真人荷官、体育竞技、棋牌桌游、捕鱼游戏等多元品类，满足不同玩家的娱乐偏好。",
      "银河娱乐始终秉持「以玩家为中心」的核心理念，不断创新和优化产品体验。我们的技术团队由超过200名工程师组成，持续投入研发资源，确保平台在安全性、稳定性和用户体验方面始终保持行业领先水平。",
      "经过十多年的发展，银河娱乐已累计服务超过500万会员，业务覆盖亚洲、欧洲、美洲等多个地区。我们以诚信经营、安全可靠、服务至上的品牌形象，赢得了广大玩家的信赖与好评。",
    ],
  },
  milestones: [
    { year: "2010", title: "品牌创立", description: "银河娱乐品牌正式成立，开启在线娱乐服务新篇章" },
    { year: "2013", title: "百万会员", description: "会员数量突破100万，获得行业多项权威大奖" },
    { year: "2016", title: "国际化布局", description: "业务拓展至欧洲和美洲市场，建立多语言服务体系" },
    { year: "2019", title: "技术创新", description: "推出自主研发游戏引擎，平台性能与安全性全面升级" },
    { year: "2022", title: "500万里程碑", description: "全球会员突破500万，荣获年度最佳在线娱乐平台称号" },
    { year: "2025", title: "AI智能升级", description: "引入AI智能推荐与风控系统，开启智慧娱乐新时代" },
  ],
  certifications: [
    { name: "BMM国际认证", icon: "ri-shield-check-line", description: "所有游戏通过BMM Testlabs严格测试认证，确保公平公正" },
    { name: "GLI权威认证", icon: "ri-verified-badge-line", description: "获得Gaming Laboratories International全面认证" },
    { name: "ISO 27001", icon: "ri-lock-line", description: "信息安全管理体系国际标准认证，保障数据安全" },
    { name: "PCI DSS", icon: "ri-bank-card-line", description: "支付卡行业数据安全标准认证，确保交易安全" },
  ],
  contactInfo: {
    email: "service@galaxyentertainment.com",
    phone: "400-888-8888",
    wechat: "GalaxyService",
    workingHours: "7×24小时 全年无休",
    address: "中国澳门特别行政区",
  },
  faqs: [
    {
      question: "如何注册银河娱乐账号？",
      answer: "访问银河娱乐官网，点击右上角「立即注册」按钮，填写手机号码、设置密码并完成短信验证，即可成功注册。整个过程仅需约2分钟。",
    },
    {
      question: "支持哪些充值方式？",
      answer: "银河娱乐支持多种充值方式，包括银行卡转账、微信支付、支付宝、USDT数字货币等。所有充值均实时到账，无需等待。",
    },
    {
      question: "提款需要多长时间？",
      answer: "普通会员提款通常在1-2小时内到账，金卡会员享受优先处理（30-60分钟），钻石会员最快15分钟即可到账。具体到账时间视银行处理速度而定。",
    },
    {
      question: "平台游戏是否公平？",
      answer: "银河娱乐所有游戏均经过BMM和GLI等国际权威机构认证，采用随机数生成器（RNG）技术，确保每局游戏结果完全随机且不可预测，公平公正。",
    },
    {
      question: "如何保障账户安全？",
      answer: "我们建议您设置强密码并定期更换，开启双重认证（2FA），不向任何人透露账户信息。平台采用256位SSL加密和多重安全防护，全方位保障您的账户安全。",
    },
    {
      question: "遇到问题如何联系客服？",
      answer: "您可以通过在线客服（7×24小时）、服务热线400-888-8888、官方微信公众号「GalaxyService」或发送邮件至service@galaxyentertainment.com联系我们。",
    },
  ],
};